import { render } from "./screenshot.vue?vue&type=template&id=79a583c5"
import script from "./screenshot.vue?vue&type=script&lang=js"
export * from "./screenshot.vue?vue&type=script&lang=js"

import "./screenshot.vue?vue&type=style&index=0&id=79a583c5&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__